export default __webpack_public_path__ + "static/origamidog-6a0d26a93d74cf22d0e096327bdbb9dc.jpg";